module.exports = __webpack_public_path__ + "img/iran-flag-dark.a2c7c8c.fb855c1d.svg";